import React from 'react';
import TestimonialsSection from '../components/TestimonialsSection';

const TestimonialsPage = () => {
  return <TestimonialsSection />;
};

export default TestimonialsPage;
